<template>
  <v-stepper alt-labels class="load-stepper">
    <v-stepper-header class="load-stepper-header px-2 center">
      <template v-for="(item, index) in steps">
        <!-- "index + 1" is the current step -->
        <div
          :key="`step-${index + 1}`"
          class="load-stepper-step center mb-auto"
          :class="{
            complete: isStepState(index + 1, 'complete'),
            active: isStepState(index + 1, 'active'),
            uncomplete: isStepState(index + 1, 'uncomplete'),
          }"
        >
          <div :key="index" class="load-stepper-step-icon center">
            <v-icon
              :small="isStepState(index + 1, 'active') ? true : false"
              :color="getStepIconColor(index + 1)"
              :class="{ spin: step === index + 1 }"
            >
              {{
                isStepState(index + 1, "active")
                  ? "mdi-timer-sand"
                  : isStepState(index + 1, "complete")
                  ? "mdi-check-circle"
                  : "mdi-circle"
              }}
            </v-icon>
          </div>

          <div class="load-stepper-step-label font-weight-thin mt-2">
            {{ item }}
          </div>
          <div
            v-if="isStepState(index + 1, 'complete')"
            class="load-stepper-step-time"
          >
            <div>{{ getStatusDate(index + 1).date }}</div>
            <div>{{ getStatusDate(index + 1).time }}</div>
          </div>
        </div>

        <v-divider
          v-if="index !== steps.length - 1"
          :key="`divider-${index + 1}`"
          class="new-divider"
        ></v-divider>
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: "LogisticLoadStepper",
  props: {
    load: {
      type: Object,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      steps: [
        "تایید اطلاعات",
        "تخصیص باربری",
        "تخصیص راننده",
        "صدور بارنامه",
        "بارگیری راننده",
        "تخلیه بار",
      ],
    };
  },
  methods: {
    getStepState(step) {
      const loadStep = this.step;
      let state = "unknown";

      if (loadStep > step) {
        state = "complete";
      } else if (loadStep === step) {
        state = "active";
      } else if (loadStep < step) {
        state = "uncomplete";
      }

      return state;
    },
    isStepState(step, state) {
      // check if correctState and state are same
      const correctState = this.getStepState(step);
      return correctState === state;
    },
    getStepIconColor(step) {
      const stepState = this.getStepState(step);
      let color = "#c6c6c6";

      if (stepState === "complete") {
        color = "var(--logistic)";
      } else if (stepState === "active") {
        color = "var(--logistic)";
      }

      return color;
    },
    getStatusDate(stepNumber) {
      let dateTimeName;

      switch (stepNumber) {
        case 1:
          dateTimeName = "validator_accepted_time";
          break;

        case 2:
          dateTimeName = "driver_waiting_time";
          break;

        case 3:
          dateTimeName = "driver_was_found_time";
          break;

        case 4:
          dateTimeName = "waybill_accepted_time";
          break;

        case 5:
          dateTimeName = "loaded_time";
          break;

        case 6:
          dateTimeName = "delivered_time";
          break;
      }

      if (!this.load.companyLoadTime || !dateTimeName) {
        return {
          date: "",
          time: "",
        };
      }

      const dateTime = this.load.companyLoadTime[dateTimeName];
      let date, time;

      if (dateTime) {
        const fomattedDate = this.$utils.formatCreatedAt(dateTime.iso);
        const JDateTime = this.$utils.getJDate(dateTime.iso, true);

        if (
          fomattedDate &&
          (fomattedDate === "امروز" || fomattedDate === "دیروز")
        ) {
          date = fomattedDate;
        } else {
          const JDate = JDateTime.split(" ")[0];
          const month = JDate.split("/")[1];
          const day = JDate.split("/")[2];

          date = month + "/" + day;
        }

        const JTime = JDateTime.split(" ")[1];
        const hour = JTime.split(":")[0];
        const min = JTime.split(":")[1];

        time = hour + ":" + min;
      }

      return {
        date,
        time,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.load-stepper {
  background-color: #f5f5f5 !important;
  box-shadow: 0 0 0 !important;
}
.load-stepper-header {
  box-shadow: 0 0 0 !important;
}
.load-stepper-step {
  display: flex;
  flex-direction: column;
  max-width: 45px;
}
.load-stepper-step-icon {
  background-color: #f5f5f5;
  z-index: 2;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  margin: 0 5px;
  position: relative;
}
.load-stepper-step.active .load-stepper-step-icon {
  border: 1px solid;
}
.load-stepper-step-icon .spin {
  animation: spin;
  animation-delay: 0.5s, 0.5s;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.new-divider {
  border-color: #c6c6c6 !important;
  margin: 11px 0 0 0 !important;
  transform: scaleX(2.3);
}
.load-stepper-step-label {
  text-align: center;
  font-size: 10px;
  display: block;
  max-width: 100%;
  word-wrap: break-word;
  color: var(--logistic);
}
.load-stepper-step-time {
  text-align: center;
  font-size: 8px !important;
  display: block;
  max-width: 100%;
  width: 100%;
  word-wrap: break-word;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin: 2px 0 0 0;
  padding: 2px 0 0 0;
  color: rgba(0, 0, 0, 0.7);
}
.load-stepper-step.uncomplete .load-stepper-step-label {
  color: rgba(0, 0, 0, 0.6);
}
</style>
